import {
  curry,
} from '@/utils/lodash';

import errorUtils from './error-utils';
import httpUtils from './external-modules/http-utils';

// const onError = curry((getStoreFn, error) => {
//   getStoreFn().dispatch('decrementPendingRequestCount', {
//     root: true,
//   });
//   getStoreFn().dispatch(
//     'notification/displayNotification',
//     {
//       title: 'Erreur !',
//       message: errorUtils.extractErrorMessage(error),
//       type: 'error',
//     },
//     {
//       root: true,
//     }
//   );
// });

// const onRequestSuccess = getStoreFn => () => {
//   getStoreFn().dispatch('incrementPendingRequestCount', {
//     root: true,
//   });
// };
//
// const onResponseSuccess = getStoreFn => () => {
//   getStoreFn().dispatch('decrementPendingRequestCount', {
//     root: true,
//   });
// };

class HttpUtils {
  constructor () {
    // Making _store a private property
    // There's no way of doing it natively yet...
    let _store;

    this.setStore = (store) => {
      _store = store;
    };

    this.getStore = () => {
      if (_store == null) {
        throw new Error('A store should be bound. Make sure to call `setStore()` first.');
      }

      return _store;
    };
  }

  createRequester (options) {
    const getStore = this.getStore.bind(this);
    const optionsWithHandlers = {
      ...options,
      headers: {
        'accept-language': process.env.VUE_APP_DEFAULT_LANGUAGE,
        wsVersion: process.env.VUE_APP_WS_VERSION || 'LIVE',
      },
      // onRequestSuccess: onRequestSuccess(getStore),
      // onResponseSuccess: onResponseSuccess(getStore),
      // onError: onError(getStore),
    };

    return httpUtils.createRequester(optionsWithHandlers);
  }
}

export default new HttpUtils();
